import { TextAnswer } from './anwer-types';
import { useReport } from './hooks/use-context';
import { AnswerData, QuestionData } from './types';

export function InitialInfos() {
  const { header } = useReport();

  return (
    <div
      style={{
        marginBottom: '20px',
        color: '#000',
      }}
    >
      <div
        style={{
          backgroundColor: '#E0F4E9',
          padding: '10px',
          borderRadius: '6px',
          marginBottom: '10px',
        }}
      >
        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
          <TextAnswer
            question={
              {
                name: 'Data:',
                answers: [
                  {
                    content: header.event_finished_at.split(' ')[0],
                  } as AnswerData,
                ],
              } as QuestionData
            }
          />

          <TextAnswer
            question={
              {
                name: 'Horário:',
                answers: [
                  {
                    content: header.event_finished_at.split(' ')[1],
                  } as AnswerData,
                ],
              } as QuestionData
            }
          />

          <TextAnswer
            question={
              {
                name: 'Ticket:',
                answers: [{ content: header.ticket_code_seq } as AnswerData],
              } as QuestionData
            }
          />
        </div>

        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
          <TextAnswer
            question={
              {
                name: 'Responsável pela análise:',
                answers: [{ content: header.author_full_name } as AnswerData],
              } as QuestionData
            }
          />
        </div>
      </div>
    </div>
  );
}
